import { createContext } from 'react';

import { defaultYAxis } from '../constants.js';
import { TimeseriesChartYAxisConfig } from '../types/timeseries-config.js';

export const TimeseriesYAxisContext =
  createContext<TimeseriesChartYAxisConfig>(defaultYAxis);

TimeseriesYAxisContext['displayName'] = 'TimeseriesYAxisContext';
